import { combineReducers } from 'redux';

import {
    AUTH_USER_BANK_ACCOUNTS_LOADED,
    BANK_ACCOUNT_UPDATED,
} from 'modules/bank-account/actions/bank-account.action';
import { AUTH_LOGOUT } from 'modules/auth/actions/authentication.action';

export const authUserBankAccount = (state = null, action) => {
    switch (action.type) {
        case AUTH_USER_BANK_ACCOUNTS_LOADED:
            return action.payload.total && action.payload.total > 0
                ? action.payload.items[0]
                : null;
        case BANK_ACCOUNT_UPDATED:
            if (state && state.pk_bank_account === action.payload.pk_bank_account) {
                return action.payload;
            }
            return state;
        case AUTH_LOGOUT:
            return null;
        default:
            return state;
    }
};

export default combineReducers({
    authUserBankAccount,
});
